import { useQuery } from "@tanstack/react-query";
import { API } from "utils/Helper";

const fetchWebsiteConfig = async () => {
  const r = await fetch(`${API}/website-config`);
  const payload = await r.json();
  if (payload && payload.success) {
    return payload.data || {};
  }
  throw new Error("Failed to fetch website config");
};

export const useWebsiteConfigQuery = () => {
  return useQuery({
    queryKey: ["websiteConfig"],
    queryFn: fetchWebsiteConfig,
    staleTime: 5 * 60 * 1000, // Cache for 5 minutes
    refetchOnWindowFocus: false,
  });
};
